import { PaginadoSitios, Sitio, ContactoSitio, ResponsableSitio } from '../../pages/sitios/models'
import { keysToSnake } from '../../utils/ObjetosUtil'
import { DivisionDeNegocio } from '../../pages/usuarios/models/usuario.type'
import { baseApi } from './base.api'

export const sitiosApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Contrato HTTP del modulo Sitios.
     * Convierte filtros y cuerpos a snake_case porque la API expone ese formato.
     */
    recuperarSitios: builder.query<
      PaginadoSitios,
      { pagina: number; registrosPorPagina: number; nombre?: string }
    >({
      query: (arg) => {
        return {
          url: `${window._env_.API_CONTEXTO_SITIOS}`,
          params: keysToSnake(arg),
        }
      }
    }),
    recuperarSitioPorId: builder.query<Sitio, string>({
      query: (idSitio) => `${window._env_.API_CONTEXTO_SITIOS}/${idSitio}`,
    }),
    recuperarSitioAutocomplete: builder.query<Sitio[], string>({
      query: (nombre) =>
        `${window._env_.API_CONTEXTO_SITIOS}/autocompletar/nombre?valor=${nombre}`,
    }),
    recuperarContactosSitio: builder.query<ContactoSitio[], string>({
      query: (idSitio) => `${window._env_.API_CONTEXTO_SITIOS}/${idSitio}/contactos`,
    }),
    guardarSitio: builder.mutation({
      query: (sitio) => {
        return {
          url: `${window._env_.API_CONTEXTO_SITIOS}/`,
          method: 'POST',
          body: keysToSnake(sitio),
        }
      },
    }),
    actualizarSitio: builder.mutation({
      query: ({ idSitio, ...sitio }) => {
        return {
          url: `${window._env_.API_CONTEXTO_SITIOS}/${idSitio}`,
          method: 'PUT',
          body: keysToSnake(sitio),
        }
      },
    }),
    /**
     * Actualiza el nivel funcional de un contacto dentro de un sitio.
     */
    actualizarNivelContacto: builder.mutation<ResponsableSitio, { idContacto: string; nivel: string }>({
      query: (arg) => {
        const { idContacto, ...params } = arg
        return {
          url: `${window._env_.API_CONTEXTO_SITIOS}/contactos/${arg.idContacto}`,
          method: 'PUT',
          params: keysToSnake(params),
        }
      },
    }),

    guardarContacto: builder.mutation<
      ResponsableSitio,
      { idSitio?: string; idUsuario: string; nivel: string }
    >({
      query: (arg) => {
        const { idSitio, ...params } = arg
        return {
          url: `${window._env_.API_CONTEXTO_SITIOS}/${arg.idSitio}/contactos`,
          method: 'POST',
          body: keysToSnake(params),
        }
      },
    }),
    eliminarContactoPorId: builder.mutation({
      query: (idContacto) => {
        return {
          url: `${window._env_.API_CONTEXTO_SITIOS}/contactos/${idContacto}`,
          method: 'DELETE',
        }
      },
    }),
    recuperarDivisionesNegocio: builder.query<DivisionDeNegocio[], string>({
      query: (divisiones) => `${window._env_.API_CONTEXTO_SITIOS}/division/${divisiones}`,
    }),
  }),
})

export const {
  useRecuperarSitiosQuery,
  useGuardarSitioMutation,
  useActualizarSitioMutation,
  useActualizarNivelContactoMutation,
  useRecuperarSitioPorIdQuery,
  useLazyRecuperarContactosSitioQuery,
  useRecuperarSitioAutocompleteQuery,
  useRecuperarContactosSitioQuery,
  useLazyRecuperarSitioAutocompleteQuery,
  useGuardarContactoMutation,
  useEliminarContactoPorIdMutation,
  useRecuperarDivisionesNegocioQuery,
} = sitiosApi
